import { render, staticRenderFns } from "./VariantsConfiguratorModal.vue?vue&type=template&id=67bb5e32"
import script from "./VariantsConfiguratorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./VariantsConfiguratorModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports